<mat-toolbar class="page-padding bg header p-t-1 p-b-1">
  <mat-toolbar-row class="hide-on-mobile">
    <a
      [routerLink]="[isAuthenticated ? '/my-cvs' : '/']"
      routerLinkActive="anchor-active"
      class="anchor app-title app-title-absolute"
      [ngClass]="{ 'app-title-left': isAuthenticated === false }"
      >{{ "app.title" | translate }}</a
    >

    <span class="filler"></span>

    <hohr-button
      *ngIf="(myCvFeaturedFlags$ | async) && displayCreateCvButton"
      [routerLink]="['/create']"
      [label]="'shared.header.create_cv' | translate | uppercase"
      [color]="(router.url | routeCheck : 'ccv') ? 'primary' : 'secondary'"
      fill="clear"
    ></hohr-button>

    <div class="anchor">
      <hohr-language-picker
        *ngIf="cultures?.length"
        [cultures]="cultures"
        [selectedCulture]="languageControl.value ?? null"
        [hasFlags]="true"
        (cultureChange)="changeLanguage($event)"
      ></hohr-language-picker>
    </div>

    <ng-container *ngIf="isAuthenticated; else loginBtn">
      <hohr-profile-menu
        *ngIf="username; else logoutBtn"
        [username]="username"
        (logout)="onLogoutClicked()"
        [imageBlob]="profilePhoto"
        [myprofileURI]="myprofileURI"
      ></hohr-profile-menu>
    </ng-container>
  </mat-toolbar-row>

  <mat-toolbar-row class="hide-on-desktop mobile-toolbar-row">
    <a
      [routerLink]="[isAuthenticated ? '/my-cvs' : '/']"
      routerLinkActive="anchor-active"
      class="p-l-0 anchor app-title"
      [ngClass]="{ 'app-title-mobile': isAuthenticated }"
      >{{ "app.title" | translate }}</a
    >
    <span class="filler"></span>
    <div class="anchor" [ngClass]="{ 'no-padding': isAuthenticated }">
      <hohr-language-picker
        *ngIf="cultures?.length"
        [cultures]="cultures"
        [selectedCulture]="languageControl.value ?? null"
        [hasFlags]="true"
        (cultureChange)="changeLanguage($event)"
      ></hohr-language-picker>
    </div>

    <hohr-button
      icon="menu-outline"
      color="primary"
      fill="outline"
      slot="icon-only"
      (click)="showMenu($event)"
    ></hohr-button>
  </mat-toolbar-row>
</mat-toolbar>

<ng-template #loginBtn>
  <hohr-button
    icon="person-outline"
    [label]="'shared.header.login' | translate"
    color="primary"
    fill="outline"
    slot="end"
    (action)="authSandbox.login()"
  ></hohr-button>
</ng-template>

<ng-template #logoutBtn>
  <hohr-button
    icon="person-outline"
    [label]="'shared.header.logout' | translate"
    color="primary"
    fill="outline"
    slot="end"
    (action)="authSandbox.logout()"
  ></hohr-button>
</ng-template>
